import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

import BoardsContext from "../../UserBoards/boardsContext";
import RemoveDialog from "../../Components/RemoveDialog";
import RenameDialog from "../../Components/RenameDialog";
import { handlePrintBoardToPDF } from "../../UserBoards/printTools";

export default function MoreOption({ board, variant }) {
  const history = useHistory();
  const { id, title } = board;
  const { t } = useTranslation();
  const { removeBoard, updateBoard } = useContext(BoardsContext);
  // Option Menu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openOptionMenu = Boolean(anchorEl);
  const handleOpenOptionMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseOptionMenu = () => {
    setAnchorEl(null);
  };
  const [openDialog, setOpenDialog] = useState({
    open: true,
    type: "",
    id: -1,
  });

  const options = [
    /*    {
      id: "rename",
      title: t("common.buttons.rename"),
      icon: <TitleOutlinedIcon />,
      onClick: () => {
        setOpenDialog((prev) => ({ ...prev, open: true, type: "rename" }));
      },
    }, */
    {
      id: "print",
      disabled: false,
      title: t("moodboards.settings.printToPDF"),
      icon: <PrintOutlinedIcon />,
      onClick: () => {
        handlePrintBoardToPDF({ id, title });
      },
    },
    {
      id: "edit",
      disabled: variant === "publicboard",
      title: t("common.buttons.edit"),
      icon: <EditOutlinedIcon />,
      onClick: () =>
        history.push({
          pathname: "/analyser",
          search: `?b=${id}`,
          state: {
            from: "moodboards",
            moodboard: board,
          },
        }),
    },
    {
      id: "remove",
      disabled: variant === "publicboard",
      title: t("common.buttons.remove"),
      icon: <DeleteOutlinedIcon />,
      onClick: () => {
        setOpenDialog((prev) => ({ ...prev, open: true, type: "remove" }));
      },
    },
  ];

  return (
    <div>
      <Box textAlign={"end"}>
        <IconButton
          aria-label="graph properties"
          onClick={handleOpenOptionMenu}
          aria-expanded={openOptionMenu ? "true" : undefined}
          aria-controls={openOptionMenu ? "graph-option-menu" : undefined}
          aria-haspopup="true"
          size="large"
        >
          <MoreVertIcon />
        </IconButton>
      </Box>
      <Menu
        id="menu-graph-options"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        disableScrollLock={true}
        open={openOptionMenu}
        onClose={handleCloseOptionMenu}
      >
        {options
          .filter((option) => !option.disabled)
          .map((option) => (
            <MenuItem
              button
              key={"Menu" + option.id}
              onClick={() => {
                option.onClick(option.id);
                handleCloseOptionMenu();
              }}
            >
              <List dense={true} style={{ margin: "0", padding: "0" }}>
                <ListItem style={{ margin: "0", padding: "0" }}>
                  <ListItemIcon>{option.icon}</ListItemIcon>
                  <ListItemText primary={option.title} />
                </ListItem>
              </List>
            </MenuItem>
          ))}
      </Menu>
      {openDialog.type === "remove" ? (
        <RemoveDialog
          open={openDialog.open}
          setOpen={setOpenDialog}
          removeFunction={() => removeBoard(id)}
          dialogTitle={t("moodboards.removeDialog.title")}
          dialogContentText={t("moodboards.removeDialog.text")}
          dialogActionCancel={t("moodboards.removeDialog.cancel")}
          dialogActionConfirm={t("moodboards.removeDialog.confirm")}
        />
      ) : null}
      {openDialog.type === "rename" ? (
        <RenameDialog
          open={openDialog.open}
          setOpen={setOpenDialog}
          renameFunction={(title) => {
            updateBoard({ id, title });
            setOpenDialog((prev) => ({ ...prev, open: false })); // close the dialog
          }}
          input={title}
          dialogTitle={t("moodboards.renameDialog.title")}
          dialogContentText={t("moodboards.renameDialog.text")}
          dialogActionCancel={t("common.actions.cancel")}
          dialogActionConfirm={t("moodboards.renameDialog.confirm")}
        />
      ) : null}
    </div>
  );
}
